/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `open` - Open
 * * `held` - Held
 * * `confirmed` - Confirmed
 * * `unavailable` - Unavailable
 * @export
 */
export const DateStatusEnum = {
    Open: 'open',
    Held: 'held',
    Confirmed: 'confirmed',
    Unavailable: 'unavailable'
} as const;
export type DateStatusEnum = typeof DateStatusEnum[keyof typeof DateStatusEnum];


export function instanceOfDateStatusEnum(value: any): boolean {
    for (const key in DateStatusEnum) {
        if (Object.prototype.hasOwnProperty.call(DateStatusEnum, key)) {
            if (DateStatusEnum[key as keyof typeof DateStatusEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function DateStatusEnumFromJSON(json: any): DateStatusEnum {
    return DateStatusEnumFromJSONTyped(json, false);
}

export function DateStatusEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): DateStatusEnum {
    return json as DateStatusEnum;
}

export function DateStatusEnumToJSON(value?: DateStatusEnum | null): any {
    return value as any;
}

export function DateStatusEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): DateStatusEnum {
    return value as DateStatusEnum;
}

